import { render } from "./InvoicePartialReturn.vue?vue&type=template&id=86de3adc&ts=true"
import script from "./InvoicePartialReturn.vue?vue&type=script&lang=ts"
export * from "./InvoicePartialReturn.vue?vue&type=script&lang=ts"

import "./InvoicePartialReturn.vue?vue&type=style&index=0&id=86de3adc&lang=scss"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__